/* unplugin-vue-components disabled */import { render } from "./HeaderFeedback.vue?vue&type=template&id=43e0345f"
import script from "./HeaderFeedback.vue?vue&type=script&lang=js"
export * from "./HeaderFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__